export default {
  // Navigation
  'nav.timer': 'ਟਾਈਮਰ',
  'nav.stopwatch': 'ਸਟਾਪਵਾਚ',
  'nav.worldclock': 'ਵਿਸ਼ਵ ਘੜੀ',
  'nav.timestamp': 'ਟਾਈਮ ਸਟੈਂਪ',
  'nav.home': 'ਹੋਮ',

  // Common buttons and actions
  'button.start': 'ਸ਼ੁਰੂ ਕਰੋ',
  'button.pause': 'ਠਹਿਰਾਓ',
  'button.stop': 'ਰੋਕੋ',
  'button.reset': 'ਮੁੜ ਨਿਰਧਾਰਿਤ ਕਰੋ',
  'button.ok': 'ਠੀਕ ਹੈ',
  'button.cancel': 'ਰੱਦ ਕਰੋ',
  'button.close': 'ਬੰਦ ਕਰੋ',
  'button.save': 'ਸੁਰੱਖਿਅਤ ਕਰੋ',
  'button.delete': 'ਮਿਟਾਓ',
  'button.edit': 'ਸੰਪਾਦਨ ਕਰੋ',
  'button.back': 'ਵਾਪਸ',
  'button.next': 'ਅਗਲਾ',
  'button.previous': 'ਪਿਛਲਾ',
  'button.submit': 'ਪ੍ਰਸਤੁਤ ਕਰੋ',
  'button.confirm': 'ਪੁਸ਼ਟੀ ਕਰੋ',
  'button.convert': 'ਰੂਪਾਂਤਰਿਤ ਕਰੋ',
  'button.copy': 'ਨਕਲ ਕਰੋ',
  'button.copied': 'ਨਕਲ ਹੋਇਆ!',
  'button.now': 'ਹੁਣ',
  'button.clear': 'ਸਾਫ ਕਰੋ',

  // Common labels
  'label.hours': 'ਘੰਟੇ',
  'label.minutes': 'ਮਿੰਟ',
  'label.seconds': 'ਸਕਿੰਟ',
  'label.milliseconds': 'ਮਿਲੀਸਕਿੰਟ',
  'label.minute': 'ਮਿੰਟ',
  'label.second': 'ਸਕਿੰਟ',
  'label.sound': 'ਆਵਾਜ',
  'label.soundAlert': 'ਆਵਾਜ',
  'label.fullscreen': 'ਪੂਰੀ ਸਕਰੀਨ',
  'label.language': 'ਭਾਸ਼ਾ',
  'label.selectLanguage': 'ਭਾਸ਼ਾ ਚੁਣੋ',
  'label.languageSelectorInfo': 'ਇਸ ਸਮੇਂ {{count}} ਭਾਸ਼ਾਵਾਂ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ। ਉੱਪਰ ਦਿੱਤੇ ਵਿਕਲਪਾਂ ਵਿੱਚੋਂ ਆਪਣੀ ਪਸੰਦੀਦਾ ਭਾਸ਼ਾ ਚੁਣੋ।',

  // Common messages
  'message.timerComplete': 'ਟਾਈਮਰ ਮੁਕੰਮਲ!',
  'message.timerCompleteDesc': 'ਤੁਹਾਡਾ ਟਾਈਮਰ ਮੁਕੰਮਲ ਹੋ ਗਿਆ',
  'message.timerCompleteBody': 'ਤੁਹਾਡਾ ਕाउਂਟਡਾ ਊਨ ਟਾਈਮਰ ਮੁਕੰਮਲ ਹੋ ਗਿਆ!',
  'message.stopwatchStarted': 'ਸਟਾਪਵਾਚ ਸ਼ੁਰੂ',
  'message.stopwatchStartedDesc': 'ਸਟਾਪਵਾਚ ਸਮਾਂ ਗਣਨਾ ਸ਼ੁਰੂ ਹੋ ਗਈ',
  'message.stopwatchStopped': 'ਸਟਾਪਵਾਚ ਰੋਕਿਆ',
  'message.stopwatchStoppedDesc': 'ਸਟਾਪਵਾਚ ਸਮਾਂ ਗਣਨਾ ਰੋਕੀ ਗਈ',
  'message.stopwatchReset': 'ਸਟਾਪਵਾਚ ਮੁੜ ਨਿਰਧਾਰਿਤ',
  'message.stopwatchResetDesc': 'ਸਟਾਪਵਾਚ ਸਿਫ਼ਰ ਤੋਂ ਮੁੜ ਨਿਰਧਾਰਿਤ ਕੀਤਾ ਗਿਆ',
  'message.notificationPermission': 'ਟਾਈਮਰ ਪੂਰਾ ਹੋਣ ਤੇ ਸਾਵਧਾਨੀਆਂ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਸੂਚਨਾਵਾਂ ਨੂੰ ਮਨਜ਼ੂਰ ਕਰੋ',
  'message.clickToEdit': 'ਸਮਾਂ ਸਿੱਧਾ ਸੰਪਾਦਨ ਕਰਨ ਲਈ ਸਮਾਂ ਸੰਖਿਆ ਉੱਤੇ ਕਲਿਕ ਕਰੋ',
  'message.addHours': '+ ਘੰਟੇ ਜੋੜੋ',
  'message.escToExit': 'ਪੂਰੀ ਸਕਰੀਨ ਤੋਂ ਬਾਹਰ ਨਿਕਲਣ ਲਈ ESC ਦਬਾਓ',
  'message.timeRemaining': '{{minutes}} ਮਿੰਟ {{seconds}} ਸਕਿੰਟ ਬਾਕੀ',
  'message.minutesRemaining': '{{minutes}} ਮਿੰਟ ਬਾਕੀ',
  'message.secondsRemaining': '{{seconds}} ਸਕਿੰਟ ਬਾਕੀ',
  'message.stopwatchTimeElapsed': '{{minutes}} ਮਿੰਟ {{seconds}} ਸਕਿੰਟ ਬੀਤੇ',
  'message.stopwatchMinutesElapsed': '{{minutes}} ਮਿੰਟ ਬੀਤੇ',
  'message.stopwatchSecondsElapsed': '{{seconds}} ਸਕਿੰਟ ਬੀਤੇ',
  'message.invalidTimestamp': 'ਅਵੈਧ ਟਾਈਮ ਸਟੈਂਪ',
  'message.invalidDateTime': 'ਅਵੈਧ ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ',
  'message.conversionError': 'ਰੂਪਾਂਤਰ ਤ੍ਰੁਟੀ',

  // Time units
  'time.am': 'AM',
  'time.pm': 'PM',
  'time.now': 'ਹੁਣ',
  'time.today': 'ਅੱਜ',
  'time.yesterday': 'ਕੱਲ',
  'time.tomorrow': 'ਭਲਕੇ',

  // Common errors
  'error.pageNotFound': 'ਸਫ਼ਾ ਨਹੀਂ ਮਿਲਿਆ',
  'error.somethingWrong': 'ਕੁਝ ਗਲਤ ਹੋਇਆ',
  'error.tryAgain': 'ਬਿਨ੍ਹਾਂ ਵਿੰਦ ਨੂੰ ਬਾਅਦ ਮਿਤ੍ਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ',

  // Footer
  'footer.about': 'timer.today ਬਾਰੇ',
  'footer.aboutDesc': 'timer.today ਇੱਕ ਪੇਸ਼ੇਵਰ ਅਨਲਾਈਨ ਸਮਾਂ ਗਣਨਾ ਟੂਲ ਪਲੇਟਫਾਰਮ ਹੈ ਜੋ ਤਿੰਨ ਮੂਲ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ:',
  'footer.timerDesc': 'ਕਸਟਮਾਈਜ਼ ਕੀਤਾ ਜਾ ਸਕਣ ਵਾਲਾ ਕାউਂਟਡ ਓਨ ਟੂਲ ਮਿੰਟ ਅਤੇ ਘੰਟਿਆਂ ਦੀ ਸਥਾਪਨਾ ਨੂੰ ਸਮਰਥਨ ਕਰਦਾ ਹੈ, ਕਾਮ ਫੋਕਸ, ਖਾਣਾ ਪਕਾਉਣ ਦਾ ਸਮਾਂ, ਸਿੱਖਿਆ ਪ੍ਰਬੰਧ ਅਤੇ ਹੋਰ ਬਹੁਤ ਕੁਝ ਲਈ ਬਿਲਕੁਲ ਸਹੀ। ਆਵਾਜ਼ ਦੀਆਂ ਸਾਵਧਾਨੀਆਂ ਅਤੇ ਡੈਸਕਟਾਪ ਸੂਚਨਾਵਾਂ ਦੀਆਂ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਹਨ।',
  'footer.stopwatchDesc': 'ਮਿਲੀਸਕਿੰਟ ਸ਼ੁੱਧਤਾ ਵਾਲਾ ਉਚ ਸ਼ੁੱਧਤਾ ਟਾਈਮ ਟੂਲ, ਖੇਲ ਸਿਖਲਾਈ, ਖਾਣਾ ਪਕਾਉਣ ਦੇ ਕੰਮ, ਪ੍ਰੀਖਿਆ ਦੀ ਮਸਖਰੀ ਅਤੇ ਹੋਰ ਸਥਿਤੀਆਂ ਲਈ ਮੌਜੂ ਹੈ ਜਿਨ੍ਹਾਂ ਲਈ ਸਹੀ ਟਾਈਮ ਗਣਨਾ ਦੀ ਜ਼ਰੂਰਤ ਹੈ।',
  'footer.worldClockDesc': 'ਵਿਸ਼ਵ ਵਾਪਾਰਕ ਸ਼ਾਰਾ ਮੁਖਿਆ ਸ਼ਹਿਰਾਂ ਦੇ ਸਮਾ ਦੀ ਸਮਾਂ ਰੇਖਾ ਪ੍ਰਦਰਸ਼ਨੀ ਸਮਲੋਤ ਕਾਲ ਖੇਤਰ ਗਣਨਾ ਦੇ ਨਾਲ, ਅੰਤਰਰਾਸ਼ਟਰੀ ਕਾਨੂੰਨੀ ਸੰਚਾਰ ਅਤੇ ਖੋਲ-ਕਲ-ਖੇਤਰ ਸਹਯੋਗ ਦੀ ਸਹੂਲਤ।',
  'footer.timestampDesc': 'Unix ਟਾਈਮ ਸਟੈਂਪ ਰੂਪਾਂਤਰਕ ਟਾਈਮ ਸਟੈਂਪ ਅਤੇ ਤਾਰੀਖ/ਸਮਾਂ ਦੇ ਵਿਚ ਦੁਬਾਰਾ ਰੂਪਾਂਤਰ ਨੂੰ ਸਮਰਥਨ ਕਰਦਾ ਹੈ, ਸਕਿੰਟ ਅਤੇ ਮਿਲੀਸਕਿੰਟ ਦੋਨ ਫਾਰਮਿਟ ਸਮਰਥਨ ਦੇ ਨਾਲ।',
  'footer.termsOfService': 'ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ',
  'footer.privacy': 'ਗੋਪਨੀਯਤਾ',
  'footer.contactUs': 'ਸਾਨੂੰ ਸੰਪਰਕ ਕਰੋ',
  'footer.changeLanguage': 'ਭਾਸ਼ਾ ਬਦਲੋ',
  'footer.moreLanguage': 'ਹੋਰ ਭਾਸ਼ਾਵਾਂ',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30 ਸਕਿੰਟ',
  'quick.add1min': '+1 ਮਿੰਟ',
  'quick.add5min': '+5 ਮਿੰਟ',
  'quick.add10min': '+10 ਮਿੰਟ',
  'quick.add30min': '+30 ਮਿੰਟ',

  // Breadcrumb
  'breadcrumb.minuteTimer': '{{minutes}} ਮਿੰਟ ਟਾਈਮਰ',
  'breadcrumb.timer': 'ਟਾਈਮਰ',
  'breadcrumb.stopwatch': 'ਸਟਾਪਵਾਚ',
  'breadcrumb.worldClock': 'ਵਿਸ਼ਵ ਘੜੀ',
  'breadcrumb.termsOfService': 'ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ',
};